/**
 * How a camera's live preview has to be fed.
 *
 * - `rtsp-ipc`    ffmpeg in the Electron main process, frames arriving over IPC.
 * - `http-poll`   repeated snapshot captures over Electron IPC. Hikvision's HTTP endpoints
 *                 use Digest auth, which an `<img>` cannot do — only the main process can.
 * - `http-mjpeg`  a plain `<img>` pointed at the MJPEG URL. Browser-only fallback; Basic auth
 *                 at best.
 *
 * Every photo modal was deciding this inline, and AllPhotosEditModal's copy was missing the
 * Electron branch entirely — so HTTP cameras there never produced a frame while RTSP worked.
 */
export type IPCameraPreviewMode = 'rtsp-ipc' | 'http-poll' | 'http-mjpeg';

export function ipCameraPreviewMode(
  camera: { protocol?: string | null },
  isElectron: boolean,
): IPCameraPreviewMode {
  // RTSP has no browser transport at all. Reporting it outside Electron too keeps callers
  // from falling through to an <img>, which can never load an rtsp:// URL.
  if (camera.protocol === 'rtsp') return 'rtsp-ipc';
  return isElectron ? 'http-poll' : 'http-mjpeg';
}
